<template>
    <div class="succeed" v-show="visible || isShow">
        <div class="tips body-leads">
            <h1 v-html="contents.title"></h1>
            <div class="tips-ctx" v-html="contents.content"></div>
            <img-loader class="sure-img" :src="sureImg"></img-loader>
        </div>
        <div class="down-app" v-if="isHidderConfigurator">
            <a class="down-app-a" @click="onClose">完成</a>
        </div>
        <div class="down-app" v-else>
            <a class="car-info" v-show="aboutes" @click="jump">配置我的爱车</a>
            <a class="down-app-a" @click="onClose">完成</a>
        </div>
    </div>
</template>

<script>
import validator from '@/util/validator.js';
import { contents, configuratorTips } from './config.js';
import params from '@/util/params.js';
import { getH5ConfiguratorLink, getAppConfiguratorLink } from '@/util/car.js';
import {
    isInNioCNApp,
    closePageBridge,
    redirectToViewBridge
} from '@/util/platform/universal'; // @/util/jsbridge/index
export default {
    props: {
        isShow: {
            type: Boolean,
            default: false
        },
        isNIOApp: {
            type: Boolean,
            default: false
        },
        isHidderConfigurator: {
            type: Boolean,
            default: false
        },
        succeedType: {
            type: [String, Number],
            default: 'default'
        },
        succeedData: {
            type: Object,
            default: () => {
                return {};
            }
        },
        carType: {
            type: String,
            default: ''
        },
        realCarType: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            visible: false,
            configuratorLinkConfig: { mp: {}, app: {}, h5: {} },
            sureImg: require('../../assets/images/sure.png')
        };
    },
    mounted() {
        let env = '';
        let carConfigFxUrl = '';
        if (process.browser) {
            env = window && window.env;
        }
        switch (env) {
            case 'dev':
                carConfigFxUrl = `https://static.nio.com/fx-static/547/fixed/car_config.dev.json?t=${Date.now()}`;
                break;
            case 'test':
                carConfigFxUrl = `https://static.nio.com/fx-static/547/fixed/car_config.test.json?t=${Date.now()}`;
                break;
            case 'stg':
                carConfigFxUrl = `https://static.nio.com/fx-static/547/fixed/car_config.stg.json?t=${Date.now()}`;
                break;
            default:
                carConfigFxUrl = `https://static.nio.com/fx-static/547/fixed/car_config.prod.json?t=${Date.now()}`;
                break;
        }
        fetch(carConfigFxUrl)
            .then(r => r.json())
            .then(data => (this.configuratorLinkConfig = data))
            .catch(e => console.log(e));
    },
    methods: {
        onOpen() {
            this.visible = true;
        },
        // 关闭页面方式
        onClose() {
            this.visible = false;
            //判读当前客户端
            if (isInNioCNApp()) {
                closePageBridge();
            } else if (validator.isWeixin()) {
                // eslint-disable-next-line
                WeixinJSBridge.call('closeWindow');
            } else if (validator.isAndroid()) {
                window.opener = null;
                window.open('about:blank', '_self', '').close();
            } else {
                window.opener = null;
                window.open('about:blank', '_self');
                window.close();
            }
        },
        jump() {
            this.$emit('trackJump');
            if (!this.aboutes.startsWith('http') && isInNioCNApp()) {
                redirectToViewBridge(this.aboutes);
            } else {
                window.location.href = this.aboutes;
            }
        }
    },
    computed: {
        contents() {
            const item = contents[this.succeedType || 'default'];
            let content = params.tempEngine(
                item.content,
                this.succeedData || {}
            );
            if (this.isHidderConfigurator || !this.aboutes) {
                content = content.replace(configuratorTips, '');
            }
            return {
                title: item.title,
                content
            };
        },
        aboutes() {
            if (!this.carType) return '';
            if (this.isNIOApp) {
                if (
                    this.configuratorLinkConfig &&
                    this.configuratorLinkConfig.app &&
                    this.configuratorLinkConfig.app[this.carType.toLowerCase()]
                ) {
                    return this.configuratorLinkConfig.app[
                        this.carType.toLowerCase()
                    ];
                } else {
                    return '';
                }
            } else {
                if (
                    this.configuratorLinkConfig &&
                    this.configuratorLinkConfig.h5 &&
                    this.configuratorLinkConfig.h5[this.carType.toLowerCase()]
                ) {
                    return this.configuratorLinkConfig.h5[
                        this.carType.toLowerCase()
                    ];
                } else {
                    return '';
                }
            }
        }
    }
};
</script>

<style lang="less">
@import '~src/assets/css/mixin.less';
@import '~src/assets/css/variable.less';
.succeed {
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 10000;
    background-color: #fff;
    color: #040B29;
    padding: 0 25 * @layout375;
    padding-top: constant(safe-area-inset-top); /* 兼容 iOS < 11.2 */
    padding-top: env(safe-area-inset-top); /* 兼容 iOS >= 11.2 */
    .tips {
        .flexbox(column);
        &.body-leads {
            h1 {
                margin-top: 5 * @layout375;
                margin-bottom: 10 * @layout375;
                font-size: 32 * @layout375;
                line-height: 45 * @layout375;
                font-weight: normal;
                text-align: left;
            }
            .tips-ctx {
                font-size: 14 * @layout375;
                line-height: 21 * @layout375;
                margin-bottom: 58 * @layout375;
                text-align: left;
            }
            .sure-img {
                width: 150 * @layout375;
                margin: 0 auto;
                background: initial;
            }
        }
    }
    .down-app {
        .center();
        position: absolute;
        left: 0;
        right: 0;
        bottom: 50 * @layout375;
        padding: 0 25 * @layout375;
        flex-direction: column;
        .down-app-a {
            .center();
            flex-direction: column;
            width: 100%;
            height: 45 * @layout375;
            background: rgba(0, 188, 188, 1);
            color: #fff;
            border-radius: 22.5 * @layout375;
            &:active, &:focus {
                background: #009499;
            }
        }
        .car-info {
            .center();
            flex-direction: column;
            width: 100%;
            height: 45 * @layout375;
            border: 1 * @layout375 solid #040B29;
            color: #040B29;
            background: transparent;
            margin-bottom: 15 * @layout375;
            border-radius: 22.5 * @layout375;
            &:focus, &:active {
                background-color: #040B29;
                color: #fff;
            }
        }
    }
}
@supports not (-webkit-touch-callout: none) {
  .succeed {
    padding-top: 25 * @layout375;
  }
}
</style>



// WEBPACK FOOTER //
// src/marketing_components/succeed/index.vue